/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-14 10:40:58
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 19:20:22
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/LinkLibrary/tools.ts
 */

import { EnumLinkType, EnumActionType } from 'src/types/common/linkType';
import { get } from 'lodash';

const organizedProductLinkData = (productData) => {
  return (productData || []).map((item) => {
    const returnItem: any = {};
    returnItem.label = item.name;
    returnItem.name = item.name;
    returnItem.uuid = item.uuid;
    returnItem.alertableName = (item.sku || '') + ' ' + item.name;
    return returnItem;
  });
};

// const organizedGeneralLinkData = (data) => {
//   return (data || []).map((item) => {
//     const returnItem: any = {};
//     returnItem.label = item.name;
//     returnItem.name = item.name;
//     returnItem.uuid = item.uuid;
//     return returnItem;
//   });
// };

const hasChildrenModule = (dataSet) => {
  return dataSet.reduce((pre, now) => {
    if (!now.children) {
      return pre;
    } else {
      return [...pre, now.key];
    }
  }, []);
};

const noChildrenModule = (dataSet) => {
  return dataSet.reduce((pre, now) => {
    if (now.children) {
      return pre;
    } else {
      return [...pre, now.key];
    }
  }, []);
};

const _hasExtraLevel = (dataSet) => {
  return (dataSet || []).reduce((pre, now) => {
    if (!now.extra) {
      return pre;
    } else {
      return [...pre, now.key];
    }
  }, []);
};

const _generatorLinkData = (scopes) => {
  const template = {
    [EnumLinkType.None]: () => ({
      key: 'None',
      children: null,
      label: 'None',
      name: 'None',
    }),
    [EnumLinkType.Product]: (data, disableFields, disableExtraFidlds) => ({
      key: 'Product',
      label: '',
      name: 'Product',
      children: organizedProductLinkData(data),
      extra: {
        returnTo: 'Product',
        name: 'Action',
        data: [
          {
            name: 'Product Detail Page',
            label: 'Product Detail Page',
            uuid: EnumActionType.ProductDetail,
            key: EnumActionType.ProductDetail,
          },
          {
            label: 'Add to Cart',
            name: 'Add to Cart',
            uuid: EnumActionType.Cart,
            key: EnumActionType.Cart,
          },
        ],
      },
    }),
    // Category: (data) => {
    //   return {
    //     key: 'Category',
    //     label: '',
    //     name: 'Collection',
    //     children: organizedGeneralLinkData(data),
    //   };
    // },
    // Campaign: (data) => {
    //   return {
    //     key: 'Campaign',
    //     label: '',
    //     name: 'Campaign',
    //     children: organizedGeneralLinkData(data),
    //   };
    // },
    // CampaignPage: (data) => {
    //   return {
    //     key: 'CampaignPage',
    //     label: '',
    //     name: 'Campaign Page',
    //     children: organizedGeneralLinkData(data),
    //   };
    // },
    // StorePage: (data) => {
    //   return {
    //     key: 'StorePage',
    //     label: '',
    //     name: 'Page',
    //     children: organizedGeneralLinkData(data),
    //   };
    // },
    // Module: (data) => {
    //   return {
    //     key: 'Module',
    //     label: '',
    //     name: 'Module',
    //     children: organizedGeneralLinkData(data),
    //   };
    // },
    // External: (data) => {
    //   const { URL, MiniProgram } = data || {};
    //   return {
    //     key: 'External',
    //     label: '',
    //     name: 'External',
    //     children: {
    //       URL: (URL || []).map((item) => {
    //         item.label = item.title;
    //         item.name = { ...item };
    //         return item;
    //       }),
    //       'Mini Program': (MiniProgram || []).map((item) => {
    //         item.label = item.title;
    //         item.name = { ...item };
    //         return item;
    //       }),
    //     },
    //   };
    // },
  };
  return (scopes || []).reduce((pre, now) => {
    if (template[now['key']]) {
      const temp = [...pre];
      const data = template[now['key']](
        now.data,
        now.disableFields || [],
        now.disableExtraFidlds || [],
      );
      temp.push(data);
      return temp;
    } else {
      return pre;
    }
  }, []);
};

const generatorLinkData = (r = {}) => {
  const initialDict = _generatorLinkData([
    { key: EnumLinkType.None, data: [] },
    { key: EnumLinkType.Product, data: r[EnumLinkType.Product] || [] },
    //   { key: 'Category', data: r[2] || [] },
    //   { key: 'Campaign', data: r[5] || [] },
    //   { key: 'CampaignPage', data: r[6] || [] },
    //   { key: 'StorePage', data: r[1] || [] },
    //   { key: 'Module', data: (r[4] || {}).sysModules || [] },
    //   { key: 'External', data: r[3] || {} },
  ]);
  const hasChildren = hasChildrenModule(initialDict);
  const noChildren = noChildrenModule(initialDict);
  const hasExtraLevel = _hasExtraLevel(initialDict);
  return {
    initialDict,
    hasChildren,
    noChildren,
    hasExtraLevel,
  };
};

const validateProductType = (link) => {
  const { uuid, action } = link || {};
  if (!uuid || !action) {
    return { result: false, code: 104317 };
  } else {
    return { result: true };
  }
};

const validateLink = (link) => {
  if (!(link || {}).linkType) {
    return { result: false, code: 104316 };
  }
  const { linkType } = link || {};
  const _check = {
    [EnumLinkType.Product]: validateProductType,
    [EnumLinkType.None]: () => {
      return { result: true };
    },
  };
  const _f = _check[linkType];
  if (_f) {
    return _f(link);
  }
  return { result: true };
};

const generateDisplayName = (linkModule) => {
  const linkType = get(linkModule, 'linkType');
  const label = get(linkModule, 'label');

  if (!linkType) {
    return '';
  } else {
    if (linkType === EnumLinkType.Product) {
      const action = get(linkModule, 'action');
      const dict = {
        [EnumActionType.ProductDetail]: 'Product Detail Page',
        [EnumActionType.Cart]: 'Add to Cart',
      };
      const a = dict[action] || '';
      return `${label} ${a}`;
    }
    return label;
  }
};

export { generatorLinkData, validateLink, generateDisplayName };
